import React from 'react';
import { FontIcon } from 'Common/components/Atoms/FontIcon';
import { Stepper } from 'Common/components/Molecules/Stepper';
import { useTheme } from '@mui/material/styles';
import {
  faUserCheck,
  faUserCircle,
  faLaptopCode,
  faClipboardList,
} from '@fortawesome/pro-light-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

const StepperIcon = ({ icon }: { icon: IconDefinition }) => {
  const theme = useTheme();
  return (
    <FontIcon
      ml={1}
      icon={icon}
      color={theme.palette.primary.main}
      size="lg"
      style={{
        filter: `drop-shadow(1px 1px 1px ${theme.palette.secondary.main})`,
      }}
    />
  );
};

export const steps = [
  {
    label: 'Getting Started',
    icon: <StepperIcon icon={faUserCheck} />,
    content:
      'Get started by providing some basic information for your profile.',
  },
  {
    label: 'Tell Us About Yourself',
    icon: <StepperIcon icon={faUserCircle} />,
    content:
      'We collect this information to better understand your level of professional experience with code review and development in general.',
  },
  {
    label: 'Code Review Skills',
    icon: <StepperIcon icon={faLaptopCode} />,
    content:
      'Which programming languages and frameworks are you comfortable reviewing code for?',
  },
  {
    label: 'Skill Confidence',
    icon: <StepperIcon icon={faClipboardList} />,
    content:
      'Let us know how experienced and confident you are reviewing code for each technology. Choose skills that you are able and willing to review code for.',
  },
];

interface Props {
  step: number;
  showTerms: boolean;
}

function SignupStepper(props: Props) {
  const { step, showTerms } = props;
  const useSteps = [];
  if (showTerms) {
    useSteps.push({
      label: 'Terms of Service',
      icon: <StepperIcon icon={faClipboardList} />,
      content: 'Agree to the PullRequest terms of service and privacy policy.',
    });
  }
  useSteps.push(...steps);

  return <Stepper steps={useSteps} activeStep={step} />;
}

export default SignupStepper;
